import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AccountAppsList from './AccountAppsList/AccountAppsList'
import AccountIntegrations from './AccountIntegrations/AccountIntegrations'
import { Navigate } from 'react-router-dom'

const AccountAdvanced = lazy(() => import('./AccountAdvanced'))
const AccountIntegrationsBucketForm = lazy(() => import('./AccountIntegrations/AccountIntegrationsBucketForm'))
const ExternalIdpForm = lazy(() => import('features/integrations/ui/IntegrationsForm/ExternalIdp/ExternalIdpForm'))
const AppForm = lazy(() => import('features/apps/ui/AppForm/AppForm'))
const WorkloadIdentityFederation = lazy(
  () => import('features/integrations/ui/IntegrationsForm/WorkloadIdentityFederation/WorkloadIdentityFederation')
)
const DatabricksOAuthU2M = lazy(
  () => import('features/integrations/ui/IntegrationsForm/DatabricksOAuthU2M/DatabricksOAuthU2M')
)
export enum AdvancedSectionsRoute {
  Apps = 'apps',
  Integrations = 'integrations'
}
const routes = [
  {
    path: 'advanced',
    element: (
      <LazyLoad>
        <AccountAdvanced />
      </LazyLoad>
    ),
    children: [
      {
        path: '',
        element: <Navigate to={AdvancedSectionsRoute.Integrations} />
      },
      {
        path: AdvancedSectionsRoute.Apps,
        element: <AccountAppsList />
      },
      {
        path: AdvancedSectionsRoute.Integrations,
        element: <AccountIntegrations />
      }
    ]
  },
  {
    path: 'advanced/apps/create',
    element: (
      <LazyLoad>
        <AppForm />
      </LazyLoad>
    )
  },
  {
    path: 'advanced/apps/:id',
    element: (
      <LazyLoad>
        <AppForm />
      </LazyLoad>
    )
  },
  {
    path: 'advanced/integrations/bucket/:integrationType/:bucketId?',
    element: (
      <LazyLoad>
        <AccountIntegrationsBucketForm />
      </LazyLoad>
    )
  },
  {
    path: 'advanced/integrations/externalIdp/:id?',
    element: (
      <LazyLoad>
        <ExternalIdpForm />
      </LazyLoad>
    )
  },
  {
    path: 'advanced/integrations/bigquery/workload-identity-federation/:id?',
    element: (
      <LazyLoad>
        <WorkloadIdentityFederation />
      </LazyLoad>
    )
  },
  {
    path: 'advanced/integrations/databricks/oauth-u2m/:id?',
    element: (
      <LazyLoad>
        <DatabricksOAuthU2M />
      </LazyLoad>
    )
  }
]

export default routes
